module.exports = __webpack_public_path__ + "static/media/arrow-down-alt2.36ef609b.svg";